import { RootState } from '@/store/types'
import { Module } from 'vuex'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { InitialState, LandingPageState } from './types'

const namespaced: boolean = true

export const landingPage: Module<LandingPageState, RootState> = {
  namespaced,
  state: InitialState,
  getters,
  actions,
  mutations
}
